import React, { useState, lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import styled from 'styled-components'
import { ToastContainer } from './components/common/Toast'
import { Header, Sidebar } from './layout'
import { BBraunTheme } from './theme'
import { getIsLoggedIn, getCurrentUser } from './services/LoginService'
import Login from './layout/Login'
import { getLogger } from './utils/logger'
import config from './config'
import { VersionBadge } from './components/common/VersionBadge'

// Lazy Loading für große Komponenten
const OverviewTable = lazy(() => import('./components/common/OverviewTable'))
const EditTranslation = lazy(() => import('./components/common/EditTranslation').then(module => ({ default: module.EditTranslation })))
const Users = lazy(() => import('./layout/Users'))
const Projects = lazy(() => import('./layout/Projects'))
const Languages = lazy(() => import('./layout/Languages').then(module => ({ default: module.Languages })))

const logger = getLogger(config.logLevel)

const AppContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
`

const HeaderSpacer = styled.div`
    height: 64px;
    flex-shrink: 0;
`

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
    width: 100%;
`

const Content = styled.div`
    display: block;
    flex: 1;
    margin: 20px 40px;
    overflow-y: auto;
`

export default (): JSX.Element => {
    logger.debug(`App stage: ${process.env.REACT_APP_STAGE}`)
    const [isLoggedIn, setIsLoggedIn] = useState(getIsLoggedIn())
    logger.debug(`User is logged: ${isLoggedIn}`)
    if (!isLoggedIn) {
        return (
            <>
                <ToastContainer />
                <Login setIsLoggedIn={setIsLoggedIn} />
            </>
        )
    }
    return (
        isLoggedIn && (
            <>
                <VersionBadge />
                <ToastContainer />
                <BrowserRouter>
                    <ThemeProvider theme={BBraunTheme}>
                        <AppContainer>
                            <Header user={getCurrentUser()} />
                            <HeaderSpacer />
                            <Wrapper>
                                <Sidebar />
                                <Content>
                                    <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>}>
                                        <Routes>
                                            <Route path="/editTranslation" element={<EditTranslation />} />
                                            <Route path="/admin/users" element={<Users />} />
                                            <Route path="/admin/projects" element={<Projects />} />
                                            <Route path="/admin/languages" element={<Languages />} />
                                            <Route path="/" element={<OverviewTable />} />
                                        </Routes>
                                    </Suspense>
                                </Content>
                            </Wrapper>
                        </AppContainer>
                    </ThemeProvider>
                </BrowserRouter>
            </>
        )
    )
}
